<template>
  <div v-cloak class="Resource bg-round bg-fff">
    <!-- 头部banner图 -->
    <div class="swiper">
      <div class="toptexts">
        <div class="imgtitle">创作训练营</div>
        <div class="texts">我们寻找新一代华语电影人</div>
      </div>
    </div>
    <div></div>
    <!-- 中间内容 -->
    <div class="Bread"><Bread :list="breadList" /></div>
    <div>
      <!-- 课程中心 -->
      <div class="main">
        <div class="top flex">
          <!-- <video
            v-if="detail.Video.length != 0"
            :src="detail.Video[0].Path"
            controls
          ></video> -->
          <div
            id="J_prismPlayer"
            v-show="detail.Video[pathIndex].Path != ''"
            class="ma-12"
          ></div>

          <img
            :src="detail.Course.Image"
            class="img_809  ld-img"
            v-show="detail.Video[pathIndex].Path == ''"
          />

          <div class="top_right">
            <div class="fon-20 height500 pa-lr-20 ma-t-30">
              {{ detail.Course.Name }}
            </div>
            <div
              class="c-8a fon-12 flex f-center pa-lr-20 ma-t-20 ma-r-20"
            >
              <img src="../img/buy.png" class="ma-r-10 img_15 img_cover" />
              {{ detail.Course.SaleCount }}人购买
              <img src="../img/iconeye.png" class="ma-l-40 ma-r-10 img_14" />
              {{ detail.Course.ViewCount }}人浏览
            </div>
            <div class="ma-l-20 ma-t-20 b-b-e ma-r-10">
              {{ detail.Course.Summary }}

              <div class="c-71 ma-t-20 fon-14">
                {{ detail.Course.Level }} / {{ detail.Course.Duration }}
              </div>
              <div class="c-71 ma-t-5 ma-b-10 fon-14">
                指导老师：{{ detail.Lecturer.Name }}
              </div>
            </div>

            <div class="absolute">
              <div
                class="c-red fon-36 ma-l-20"
                v-if="detail.Course.SalePrice != 0"
              >
                <span class="linethrough fon-16 c-8a"
                  >￥{{ detail.Course.Price }}</span
                >
                <span class="fon-18">￥</span>{{ detail.Course.SalePrice }}
              </div>
              <div class="c-a8 fon-24 ma-l-20 flex c-red" v-else>免费</div>
              <div
                class="btn_green pointer"
                @click="openPay()"
                v-if="!detail.Course.IsBuy"
              >
                {{ detail.Course.SalePrice == 0 ? '我要报名' : '我要报名' }}
              </div>
              <div class="btn_green pointer" v-else @click="goThird()">
                {{ detail.Course.ThirdUrl == "" ? '已购买' : '去学习' }}
              </div>
            </div>
          </div>
        </div>

        <!-- 课程介绍 -->
        <div class="bottom">
          <div class="bottom_left ma-t-20 min_height500">
            <div class="fixed">
              <div
                class="study"
                v-show="
                  activeName == 0 && scrollTop > 1100 && !detail.Course.IsBuy
                "
                @click="openPay()"
              >
                我要报名
              </div>
            </div>
            <el-tabs @tab-click="handleClick" v-model="activeName" class="pa-tb-20">
              <el-tab-pane
                v-for="kind in kinds"
                :key="kind.Id"
                :label="kind.Name"
                :name="kind.Id"
                class="width471"
              ></el-tab-pane>
            </el-tabs>
            <div class="pa-lr-30">
              <div
              v-show="activeName == 0"
              class="fon-16 line-height33 vhtml course-content"
              v-html="detail.Course.Content"
            ></div>
            </div>

            <!-- 视频 -->
            <!-- <div v-show="activeName == 1" class="pa-lr-20 fon-16">
              <div v-show="detail.Video.length == 0" class="c-a8">
                暂无相关视频～
              </div>

              <div v-show="detail.Video.length > 0" class="flex">
                <div>
                  <block v-for="(item, index) in detail.Video" :key="index">
                    <div class="fon-12 ma-l-10 flex f-between ma-b-20 width300">
                      <div>
                        <div>{{ item.Name }}</div>
                        <div>时长：{{ item.Duration }}</div>
                      </div>
                      <div
                        class="green_btns pointer"
                        v-if="item.Path != ''"
                        @click="toSee(item.Path, item.IsFree, index, 1)"
                      >
                        {{
                          item.IsFree || detail.Course.IsBuy
                            ? "立即观看"
                            : "免费试看"
                        }}
                      </div>
                      <div v-else></div>
                    </div>
                  </block>
                </div>
              </div>
            </div> -->

            <!-- 附件 -->
            <div v-show="activeName == 1" class="pa-lr-20">
              <div
                class="ma-b-20"
                @click="isAttachment = false"
                v-if="isAttachment"
              >
                <div
                  style="background: #fb004d; width: 80px; height: 35px"
                  class="c-fff flex f-center f-jcenter b-r-10 pointer"
                >
                  返回
                </div>
              </div>
              <div v-if="detail.Attachment.length > 0 && !isAttachment">
                <div class="fujian_box">
                  <div
                    class="flex f-center ma-b-10 b-b-e pointer"
                    v-for="(item, index) in detail.Attachment"
                    :key="index"
                    @click="downLoad(item)"
                  >
                    <img src="../img/wenjian.png" class="img_64" />
                    <div class="ma-l-20">{{ item.Name }}</div>
                  </div>
                </div>
              </div>
              <div
                v-if="detail.Attachment.length == 0 && !isAttachment"
                class="c-a8"
              >
                暂无相关附件～
              </div>
              <div
                v-if="isAttachment"
                class="pa-lr-20"
                v-html="detailAttachment.Detail"
              ></div>
            </div>
            <!-- 相关推荐 -->
            <div v-show="activeName == 2" class="pa-lr-20">
              <div v-if="detail.RelatedList.length > 0">
                <div class="three_boxssl ma-center">
                  <div class="flex f-wrap width100">
                    <div
                      class="boxs ma-r-20 ma-b-20"
                      v-for="(item, index) in detail.RelatedList"
                      @click="toDetail(item.CourseId)"
                      :key="index"
                    >
                      <img :src="item.CourseImage" class="img_263 b-r-10" />
                      <img :src="item.LecturerImage" class="img_30" />
                      <div class="ma-t-15 pa-lr-10 flex f-between">
                        <span class="fon-12">{{ item.LecturerName }} </span>
                        <span class="c-red" v-if="item.SalePrice != 0"
                          ><span class="linethrough fon-12 c-8a"
                            >￥ {{ item.Price }} </span
                          >￥ {{ item.SalePrice }}
                        </span>
                        <span class="c-a8" v-else>免费</span>
                      </div>
                      <div class="t-omit-2 ma-t-15 pa-lr-10 fon-14 weight500">
                        {{ item.CourseName }}
                      </div>
                      <div class="c-71 ma-t-10 pa-lr-10 fon-14">
                        {{ item.CourseLevel }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else class="c-a8">
                <Empty :isShow="true"></Empty>
              </div>
            </div>
            <!-- 课程表 -->

            <!-- <div class="ma-l-20 ma-t-10">
              <ul
                class="infinite-list"
                style="overflow: auto; height: 200px"
                v-if="detail.Video.length > 0 && !detail.Video[0].none"
              >
                <li
                  v-for="(item, index) in detail.Video"
                  :key="index"
                  class="infinite-list-item"
                >
                  <div class="flex f-between ma-b-10 ma-r-10">
                    <div
                      :class="pathIndex == index ? 'c-009294' : ''"
                      class="width42"
                    >
                      {{ item.Alias }}
                    </div>
                    <div
                      class="width200 t-left t-omit-1"
                      :class="pathIndex == index ? 'c-009294' : ''"
                    >
                      {{ item.Name }}
                    </div>
                    <div v-if="item.Path != ''">
                      <div
                        class="width42 flex f-center f-jcenter pointer"
                        v-show="pathIndex != index"
                        @click="toSee(item.Path, item.IsFree, index, 1)"
                      >
                        <img src="../img/play.png" />
                      </div>
                      <div class="c-009294 width42" v-show="pathIndex == index">
                        播放中
                      </div>
                    </div>
                    <div v-else class="width42"></div>
                  </div>
                </li>
              </ul>
              <div v-else class="c-a8">暂无相关课程视频～</div>
            </div> -->

            <div v-show="activeName == 3" class="">
              <div v-if="detail.Video.length > 0 && !noVideo">
                <div
                  v-for="(item, index) in detail.Video"
                  :key="index"
                  class="domicile1"
                >
                  <div
                    class="hover-gray pa-lr-20 pa-t-10"
                    :class="pathIndex == index && !noVideo ? 'c-009294' : ''"
                  >
                    <div class="fon-16 font-bold ma-t-10 flex">
                      <div
                        class="c-a8 width37"
                        :class="
                          pathIndex == index && !noVideo ? 'c-009294' : ''
                        "
                      >
                        {{ bigNum > index + 1 ? '0' + (index + 1) : index + 1 }}
                      </div>
                      <div>{{ item.Alias }}： {{ item.Name }}</div>
                    </div>
                    <div class="c-a8 flex ma-t-10 b-b-1-e3 pa-b-20">
                      <div class="width37"></div>
                      <div class="flex f-center">
                        <img src="../img/play.png" alt="" srcset="" class="" />
                        <div class="ma-l-10">
                          视频 |
                          {{
                            parseInt(item.Duration) > 60
                              ? parseInt(item.Duration / 60) +
                                '分' +
                                (parseInt(item.Duration) % 60) +
                                '秒'
                              : parseInt(item.Duration) + '秒'
                          }}
                        </div>
                      </div>
                    </div>
                    <div>
                      <div
                        @click="needBuy"
                        class="need-buy c-999 pointer"
                        v-show="!item.IsFree && !detail.Course.IsBuy"
                      >
                        <span>需要购买</span>
                      </div>

                      <div
                        class="need-buy c-009294"
                        v-show="
                          pathIndex == index &&
                          (item.IsFree || detail.Course.IsBuy)
                        "
                      >
                        <span>播放中</span>
                      </div>
                      <div
                        class="need-buy c-009294 pointer"
                        v-show="
                          pathIndex != index &&
                          (item.IsFree || detail.Course.IsBuy)
                        "
                        @click="toSee(item.Path, item.IsFree, index, 1)"
                      >
                        <span>立即观看</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else class="c-a8 ma-l-20">
                <Empty :isShow="true"></Empty>
              </div>
            </div>
            <!-- 考试 -->
            <div
              v-show="(activeName == 4) & detail.Course.IsBuy"
              class="center"
            >
              <div v-if="detail.MemberExam && detail.MemberExam.IsExam">
                <div class="t-center ma-b-20">您已经完成了考试</div>
                <div>
 <img :src="detail.MemberExam.CertificatePath" alt="获得的证书" srcset="" class="certimg" />
                </div>
              </div>
              <div v-else>
                <div class="t-center ma-b-20">您未完成考试，可以参加考试</div>
                <div
                  class="btn_green pointer flex f-center f-jcenter fon-20"
                  @click="toExam()"
                >
                  去考试
                </div>
              </div>
            </div>
          </div>

          <!-- <div class="bottom_right ma-t-20">
            <div
              class="
                ma-t-20 ma-lr-20
                fon-20
                flex
                f-center
                c-009294
                b-b-e
                pa-b-10
              "
            >
              <img src="../img/tishi.png" class="img_28" /><span class="ma-l-10"
                >课程提示</span
              >
            </div>
            <div class="ma-tb-10 ma-l-20">
              <img src="../img/three_ava.png" class="img_ava" />

              <ul class="fon-16 c-999 ma-lr-20">
                <el-tooltip
                  class="item"
                  :content="item.Summary"
                  placement="left"
                  effect="light"
                  v-for="(item, index) in helpsList"
                  :key="index"
                >
                  <li style="list-style-type: disc" class="ma-b-10 pointer">
                    {{ item.Name }}
                  </li>
                </el-tooltip>
              </ul>
              <div class="flex ma-t-15">
              </div>
              <div class="pa-lr-40 ma-t-40 line-height26">
              </div>
            </div>
          </div> -->
          
        </div>
      </div>

      <el-dialog
        :visible.sync="pay"
        width="40%"
        :show-close="true"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :before-close="handleClose"
      >
        <div>
          <div class="b-b-e pa-b-20">
            <div class="flex">
              <div class="green_tags"></div>
              <div class="fon-16 ma-l-10">课程信息</div>
            </div>
            <div class="ma-t-20 ma-lr-20 flex">
              <img :src="detail.Course.Image" class="img_204 img_cover" />
              <div class="ma-l-20 position">
                <span> {{ detail.Course.Name }}</span>
                <div class="money flex f-between width250 f-center">
                  <div>
                    <span class="linethrough fon-16 c-8a"
                      >￥{{ detail.Course.Price }}</span
                    >
                    <span class="fon-18 c-red"
                      >￥{{ detail.Course.SalePrice }}</span
                    >
                  </div>
                  <span class="fon-18 c-0">×1</span>
                </div>
              </div>
            </div>
          </div>

          <div>
            <div class="flex ma-t-20">
              <div class="green_tags"></div>
              <div class="fon-16 ma-l-10">支付信息</div>
            </div>
            <div class="flex f-jcenter t-center ma-t-30" v-show="!weixinPay">
              <div
                class="flex flex-direction f-center ma-r-40 t-center pointer"
                @click="PayMoney('wx')"
              >
                <img src="../img/wx.png" class="qrcode img_cover ma-b-10" />

                <div class="t-center">选择微信支付</div>
              </div>
              <!-- <div
                class="flex flex-direction f-center ma-l-40 pointer"
                @click="PayMoney('zfb')"
              >
                <img src="../img/zfb.png" class="qrcode img_cover ma-b-10" />
                <div class="t-center">选择支付宝支付</div>
              </div> -->
            </div>
            <div
              v-show="weixinPay"
              class="flex f-center f-jcenter flex-direction"
            >
              <div id="qrCode"></div>
              <div class="flex f-center ma-t-20 fon-24">
                <img src="../img/wx.png" class="img_40 ma-r-10" />微信支付
              </div>
            </div>

            <div class="flex ma-t-70 f-around">
              <!-- <div class="btn_green flex f-center f-jcenter">支付成功</div>
              <div
                class="btn_white flex f-center f-jcenter"
                @click="pay = false"
              >
                取消支付
              </div> -->
            </div>
          </div>
        </div>
      </el-dialog>
    </div>
    <el-dialog
      :visible.sync="alipayOpen"
      width="40%"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="flex f-center flex-direction pa-tb-40 fon-18 ma-t-20">
        <img src="../img/zfb.png" class="qrcode img_cover ma-b-10" />
        您正在支付中～

        <div class="flex ma-t-40 width50 f-around">
          <div class="btn_green1 ma-r-20 pointer" @click="successPay">
            已完成支付
          </div>
          <div class="btn_green2 pointer" @click="failPay">取消</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<style lang="scss" >
    /* 大屏 宽度大于768 */
    @media (min-width: 768px) {
        @import 'https://g.alicdn.com/de/prismplayer/2.8.2/skins/default/aliplayer-min.css';

        .certimg {
            width: 220px;
        }

        .course-content {
            width: 70%;
            margin: 0 auto;
        }

        .ld-img {
            box-sizing: border-box;
            padding: 30px 0 10px 30px;
        }

        .btn_green1 {
            width: 150px;
            height: 40px;
            font-size: 16px;
            background: #fb004d;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #fff;
            border-radius: 50px;
        }

        .btn_green2 {
            width: 150px;
            height: 40px;
            font-size: 16px;
            color: #fb004d;
            display: flex;
            justify-content: center;
            align-items: center;
            border: 1px solid #fb004d;
            border-radius: 50px;
        }

        .img_42 {
            width: 42px;
            height: 42px;
        }

        .img_28 {
            width: 28px;
            height: 28px;
        }

        .ma-tb-5 {
            margin: 5px 0;
        }

        .pointer {
            cursor: pointer;
        }

        .vhtml img {
            max-width: 100%;
        }

        .c-fa {
            background: #fafafa;
        }

        .three_boxssl {
            width: 100%;
            height: auto;

            .boxs {
                width: 232px;
                height: 352px;
                background: #ffffff;
                box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.2);
                border-radius: 10px;
                position: relative;

                .img_263 {
                    width: 232px;
                    height: 220px;
                }

                .img_30 {
                    width: 30px;
                    height: 30px;
                    border-radius: 50%;
                    position: absolute;
                    top: 205px;
                    left: 10px;
                }
            }
        }

        .fujian_box {
            width: 769px;
        }

        .width200 {
            width: 200px;
        }

        .width42 {
            width: 42px;
        }

        .ma-12 {
            margin: 12px;
        }

        .c-009294 {
            color: #fb004d;
        }

        .green_btns {
            width: 70px;
            height: 30px;
            background: #fb004d;
            color: #fff;
            border-radius: 50px;
            display: flex;
            justify-content: center;
            align-items: center;
        }

        .width120 {
            width: 120px !important;
        }

        .width300 {
            width: 300px;
        }

        .img_64 {
            width: 64px;
            height: 64px;
        }

        .min_height500 {
            min-height: 500px;
        }

        .video_width {
            width: 230px;
            height: auto;
        }

        .img_809 {
            width: 809px;
            height: 605px;
        }

        .Resource {
            min-width: 1200px;
            background: rgba(245, 247, 250, 1);
        }

        .Resource .swiper {
            width: 100%;
            height: 314px;
            background-image: url(../img/three_1.png);
            background-size: 100% 100%;
            background-repeat: no-repeat;
            position: relative;

            .toptexts {
                width: 736px;
                position: absolute;
                top: 28%;
                margin: 0 auto;
                left: 50%;
                margin-left: -368px;
                font-size: 20px;
                font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
                color: #fff;
                opacity: 0.75;
                text-align: center;

                .texts {
                    line-height: 30px;
                    letter-spacing: 3px;
                    font-size: 16px;
                }

                .imgtitle {
                    font-size: 24px;
                    font-weight: bold;
                    margin-bottom: 20px;
                }
            }
        }

        .img_40 {
            width: 30px;
            height: 30px;
        }

        .width250 {
            width: 250px;
        }

        .ma-t-60 {
            margin-top: 60px !important;
        }

        .ma-t-10 {
            margin-top: 10px !important;
        }

        .main {
            width: 100%;
            height: auto;
            display: flex;
            flex-wrap: wrap;
        }

        .top {
            height: 630px;
            margin: 0 auto;

            video {
                width: 809px;
                height: 100%;
                padding: 0;
                margin: 0;
                object-fit: fill;
            }

            .top_right {
                position: relative;
                width: 390px;
                padding-right: 20px;

                .absolute {
                    position: absolute;
                    bottom: 30px;

                    .btn_green {
                        width: 260px;
                        height: 50px;
                        background: #fb004d;
                        border-radius: 25px;
                        color: #fff;
                        font-size: 18px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        margin-left: 60px;
                        margin-top: 20px;
                    }
                }
            }
        }

        .bottom {
            width: 1200px;
            min-height: 444px;
            display: flex;
            justify-content: space-between;
            margin: 0 auto;

            .bottom_left {
                position: relative !important;
                width: 100%;
                padding: 0 0 30px;
                // background: #ffffff;

                .fixed {
                    position: fixed !important;
                    width: 100%;
                    z-index: 2;
                    bottom: 200px;
                    display: flex;
                    justify-content: flex-end;

                    .study {
                        cursor: pointer;
                        // right: 600px;
                        width: 120px;
                        height: 40px;
                        font-size: 14px;
                        background: #fb004d;
                        color: #fff;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        border-radius: 30px;
                    }
                }

                .el-tabs__header {
                    display: flex;
                    margin-left: 20px;
                    justify-content: center;
                }

                .el-tabs__content {
                    min-width: 1080px;
                    margin: 0 auto;
                }

                .el-tabs__item {
                    padding: 0 60px;
                    font-size: 14px;
                    font-family: MicrosoftYaHei;
                    color: #333333;
                }

                .el-tabs__active-bar {
                    height: 4px;
                    font-weight: bold;
                    background: #fb004d;
                }

                .is-active {
                    font-size: 14px;
                    font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
                    font-weight: bold;
                    color: #fb004d;
                }

                .el-tabs__content {
                    margin-top: 45px;
                }
            }

            .bottom_right {
                width: 357px;
                height: 550px;
                background: #ffffff;

                .img_ava {
                    width: 80px;
                    height: 80px;
                    border-radius: 50%;
                }

                .green_tags {
                    width: 91px;
                    height: 30px;
                    color: #fff;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    font-size: 12px;
                    background: #fb004d;
                    border-radius: 50px;
                }
            }
        }

        .line-height26 {
            line-height: 26px;
        }

        .line-height33 {
            line-height: 33px;
        }

        .el-dialog {
            display: flex;
            flex-direction: column;
            margin: 0 !important;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            /*height:600px;*/
            max-height: calc(100% - 30px);
            max-width: calc(100% - 30px);

            .el-dialog__header {
                padding: 0;
                height: 0;
            }

            .img_204 {
                width: 204px;
                height: 116px;
            }
        }

        .el-dialog .el-dialog__body {
            flex: 1;
            padding: 16px;
        }

        .green_tags {
            width: 4px;
            height: 20px;
            background: #fb004d;
            border-radius: 2px;
        }

        .b-b-e {
            border-bottom: #eee solid 1px;
        }

        .position {
            position: relative;
        }

        .money {
            position: absolute;
            bottom: 20px;
        }

        .qrcode {
            width: 80px;
            height: 80px;
        }

        .btn_green {
            width: 220px;
            height: 40px;
            background: #fb004d;
            border-radius: 20px;
            color: #fff;
        }

        .btn_white {
            width: 220px;
            height: 40px;
            background: #ffffff;
            border: 1px solid #fb004d;
            border-radius: 20px;
            color: #fb004d;
        }

        .ma-t-70 {
            margin-top: 70px;
        }

        .img_15 {
            width: 15px;
            height: 15px;
        }

        .Bread {
            width: 1200px;
            margin: 20px auto;
        }

        .width37 {
            width: 37px;
        }

        .hover-gray:hover {
            background: #fafafa;
        }

        .hover-gray:hover .need-buy {
            opacity: 1;
        }

        .hover-gray {
            transition: all ease-out 0.1s;
        }

        .need-buy {
            opacity: 0;
            position: absolute;
            bottom: 30px;
            right: 20px;
            transition: all ease-out 0.1s;
        }

        .b-r-10 {
            border-radius: 10px;
        }

        .img_contain {
            object-fit: contain;
        }

        .img_cover {
            object-fit: cover;
        }
    }
    #J_prismPlayer video{
      object-fit: contain !important;
    }
</style>
<script src="https://g.alicdn.com/de/prismplayer/2.8.2/aliplayer-min.js"></script>

<script src="https://g.alicdn.com/de/prismplayer/2.8.2/json/json.min.js"></script>
<!-- <script src="https://g.alicdn.com/de/prismplayer/2.9.16/aliplayer-min.js"></script> -->

<script src="@/aliplayerComponent.js"></script>
<script>
    var _this
    import {
        ClassDetail,
        orderAdd,
        orderPay,
        getVideo,
        getHelps,
        PayResult,
        getuser
    } from '../api.js'
    import QRCode from 'qrcodejs2'
    import Bread from '../components/Bread.vue'
    import { Loading } from 'element-ui'
    // studycollect
    export default {
        name: 'Learn-detail',
        components: {
            Bread
        },
        data() {
            return {
                activeName: '0',
                pathIndex: 0,
                kinds: [
                    { Name: '课程介绍', Id: '0' },
                    { Name: '课程表', Id: '3' },
                    // { Name: '相关附件', Id: '1' },
                    { Name: '更多推荐', Id: '2' }
                ],
                detail: {
                    Video: [{ Path: '' }],
                    Course: {},
                    Attachment: [],
                    Lecturer: {},
                    RelatedList: []
                },
                bigNum: 10,
                pay: false,
                paynum: 0,
                Key: '',
                type: 'weixin', //支付方式
                weixinPay: false, //是微信支付展示二维码
                player: null,
                token: '',
                breadList: [
                    { name: '创作训练营', path: '/creation/index' },
                    { name: '正文', path: '/creation/detail' }
                ],
                interval: '',
                //课程表
                curriculumList: [{}],
                noVideo: false,
                scrollTop: 0,
                loadingInstance1: '',
                alipayOpen: false,
                isAttachment: false,

                detailAttachment: {},
                helpsList: []
            }
        },

        created() {
            _this = this

            this.id = this.$route.query.id
            this.token = localStorage.getItem('AccessToken') || ''
            this.getDetail()
            this.getHelp()
            window.scroll(0, 0)
        },
        beforeRouteEnter(to, from, next) {
            console.log("to");
            console.log(to);
            //获取用户token等信息并且缓存
            if (to.query.uToken) {
                let data = JSON.parse(to.query.uToken);
                localStorage.setItem("AccessToken", data.AccessToken);
                localStorage.setItem("RefreshToken", data.RefreshToken);
                localStorage.setItem("AccessTokenTime", data.AccessTokenTime);
                localStorage.setItem("RefreshTokenTime", data.RefreshTokenTime);
                localStorage.setItem("username", data.username);
            }
            getuser().then((res) => {
                if (res.data.Code == 1001) {
                    //如果登录过期，则清除token
                    // localStorage.clear()
                }
            });

            window.scroll(0, 0);
            // 判断是否从详情页面回来

 
            next();
               
        },

        // 其他页面进来时更新初始数据
        activated() {
            console.log('909090------')
        },
        mounted() {
            window.addEventListener('scroll', this.getScroll)
        },
        destroyed() {
            window.removeEventListener('scroll', this.getScroll)
            clearInterval(_this.interval)
        },

        methods: {
            toExam() {
                this.$router.push({
                    path: '/Exam',
                    query: {
                        paths: '/creation/detail',
                        name: '考试'
                    }
                })
            },
            toStart(e) {
                console.log(e)
                if (e == 0 && _this.breadAttachment.length > 1) {
                    _this.isAttachment = false
                }
            },
            successPay() {
                location.reload()
            },
            failPay() {
                _this.alipayOpen = false
            },
            toHelp() {
                this.$message({
                    message: '敬请期待！',
                    type: 'success'
                })
            },
            //监听滚动
            getScroll() {
                this.scrollTop =
                    window.pageYOffset ||
                    document.documentElement.scrollTop ||
                    document.body.scrollTop
                console.log(this.scrollTop)
            },
            needBuy() {
                let token = localStorage.getItem('AccessToken') || ''
                if (!token) {
                    this.$confirm('您还未登录请先登录?', '提示', {
                        confirmButtonText: '去登录',
                        cancelButtonText: '取消',
                        type: 'warning'
                    })
                        .then(() => {
                            this.$router.push('/login')
                        })
                        .catch(() => {
                            return false
                        })
                } else {
                    this.$message({
                        message: '请先购买！',
                        type: ''
                    })
                }
            },
            login() {
                let token = localStorage.getItem('AccessToken') || ''
                if (!token) {
                    this.$confirm('您还未登录请先登录?', '提示', {
                        confirmButtonText: '去登录',
                        cancelButtonText: '取消',
                        type: 'warning'
                    })
                        .then(() => {
                            this.$router.push('/login')
                        })
                        .catch(() => {
                            return false
                        })
                } else {
                    return true
                }
            },
            doPlayer(vid, playAuth, v, i = 0) {
                var autoplay = false
                if (i == 1) {
                    autoplay = true
                }
                if (this.detail.Course.IsBuy || v) {
                    this.player = new Aliplayer({
                        id: 'J_prismPlayer', // 播放器外层容器的dom元素id。
                        vid: vid, // 视频id
                        playauth: playAuth, // 播放凭证

                        qualitySort: 'asc',
                        format: 'mp4',
                        mediaType: 'video',
                        language: 'zh-cn', // 如果未设置，则采用浏览器语言。 可选值为‘zh- cn’、‘en - us’或其它值。
                        encryptType: 1, // 加密类型，播放点播私有加密视频时，设置值为1，默认值为0。
                        width: '65%',
                        height: '95%',
                        cover: this.detail.Course.Image,
                        autoplay: autoplay, // 自动播放
                        isLive: false, // 播放内容是否为直播，直播时会禁止用户拖动进度条。
                        rePlay: false, // 循环播放
                        playsinline: true, // H5是否内置播放
                        preload: true, // 自动加载，目前仅h5可用
                        controlBarVisibility: 'hover',
                        useH5Prism: true, // 使用H5播放器
                        diagnosisButtonVisible: false // 是否显示检测按钮
                    })
                } else {
                    this.player = new Aliplayer({
                        id: 'J_prismPlayer', // 播放器外层容器的dom元素id。
                        vid: vid, // 视频id
                        playauth: playAuth, // 播放凭证
                        cover: this.detail.Course.Image,
                        qualitySort: 'asc',
                        format: 'mp4',
                        mediaType: 'video',
                        language: 'zh-cn', // 如果未设置，则采用浏览器语言。 可选值为‘zh- cn’、‘en - us’或其它值。
                        encryptType: 1, // 加密类型，播放点播私有加密视频时，设置值为1，默认值为0。
                        width: '65%',
                        height: '95%',
                        autoplay: autoplay, // 自动播放
                        isLive: false, // 播放内容是否为直播，直播时会禁止用户拖动进度条。
                        rePlay: false, // 循环播放
                        playsinline: true, // H5是否内置播放
                        preload: true, // 自动加载，目前仅h5可用
                        controlBarVisibility: 'hover',
                        useH5Prism: true, // 使用H5播放器
                        components: [
                            {
                                name: 'PreviewVodComponent',
                                type: AliPlayerComponent.PreviewVodComponent,
                                /* 第一个参数是试看时长, 单位为分钟 */
                                /* 第二个参数可以传一个 Dom 字符串, 他将会替换默认的'试看已结束...'等文字 */
                                args: [30, '', '请购买']
                            },
                            {
                                name: 'MemoryPlayComponent',
                                type: AliPlayerComponent.MemoryPlayComponent
                            }
                        ],
                        diagnosisButtonVisible: false // 是否显示检测按钮
                    })
                }

                // 播放结束时执行
            },
            toSee(e, v, index, i = 0) {
                var that = this
                this.pathIndex = index
                let data = {
                    videoId: e
                }
                getVideo(data).then((res) => {
                    console.log(res)
                    if (res.data.Code == 0) {
                        if (i == 0) {
                            that.doPlayer(e, res.data.Data.PlayAuth, v)
                        } else {
                            this.player.dispose()
                            // $('#J_prismPlayer').empty();
                            that.doPlayer(e, res.data.Data.PlayAuth, v, 1)
                            // this.player.replayByVidAndPlayAuth(e, res.data.Data.PlayAuth);
                        }
                    }
                })
            },
            handleClose(done) {
                this.$confirm('确认关闭？')
                    .then((_) => {
                        console.log(_)
                        this.weixinPay = false
                        let a = document.getElementById('qrCode')
                        a.innerHTML = ''
                        done()
                    })
                    .catch((_) => {
                        console.log(_)
                    })
            },
            downLoad(e) {
                if (!this.detail.Course.IsBuy) {
                    this.$message({
                        message: '请先购买课程',
                        type: 'warning'
                    })
                } else {
                    _this.isAttachment = true
                    _this.detailAttachment = e
                }
            },
            //支付方式
            PayMoney(e) {
                let token = localStorage.getItem('AccessToken') || ''
                this.type = 'weixin'
                if (e == 'zfb') {
                    this.type = 'alipay'
                }
                let data = {
                    Key: this.key,
                    Type: this.type,
                    Token: token
                }
                orderPay(data).then((res) => {
                    console.log(res)
                    if (res.data.Code == 0) {
                        console.log(456789)
                        if (this.type == 'weixin') {
                            this.weixinPay = true
                            _this.interval = setInterval(() => {
                                _this.getPayState(res.data.Data.PayId)
                            }, 1000 * 2)
                            new QRCode(document.getElementById('qrCode'), {
                                text: res.data.Data.Qrcode,
                                width: 150,
                                height: 150,
                                colorDark: '#333333', //二维码颜色
                                // colorLight: '#ffffff', //二维码背景色
                                correctLevel: QRCode.CorrectLevel.L //容错率，L/M/H
                            })
                        } else {
                            _this.alipayOpen = true
                            _this.pay = false
                            //  _this.loadingInstance1 = Loading.service({ fullscreen: true,text:'支付中' });
                            this.interval = setInterval(() => {
                                _this.getPayState(res.data.Data.PayId)
                            }, 1000 * 2)
                            localStorage.setItem('alipayForm', res.data.Data.Body)
                            const { href } = this.$router.resolve({
                                name: 'alipay'
                            })
                            window.open(href, '_blank')
                        }
                    }
                })
            },
            getPayState(e) {
                let token = localStorage.getItem('AccessToken') || ''
                PayResult({ PayId: e, Token: token })
                    .then((result) => {
                        if (result.data.Data) {
                            _this.$message.success('支付成功')
                            clearInterval(_this.interval)
                            setTimeout(() => {
                                //  _this.loadingInstance1.close();
                                location.reload()
                            }, 1500)
                        }
                    })
                    .catch((err) => { })
            },
            getDetail() {
                let token = localStorage.getItem('AccessToken') || ''

                let data = {
                    id: this.$route.query.id,
                    token: token
                }
                ClassDetail(data).then((res) => {
                    if (res.data.Code == 0) {
                        this.detail = res.data.Data
                        //设置缓存
                        localStorage.setItem('examid', res.data.Data.Course.ExamId) //考试id
                        localStorage.setItem('kid', res.data.Data.Course.Id) //课程id
                        if (res.data.Data.Video.length > 0) {
                            if (res.data.Data.Course.IsBuy) {
                                this.kinds = [
                                    { Name: '课程表', Id: '3' },
                                    { Name: '课程介绍', Id: '0' },
                                    { Name: '相关附件', Id: '1' },
                                    { Name: '相关推荐', Id: '2' }
                                ]
                                this.activeName = '3'
                                this.detail.Attachment.forEach((v, e) => {
                                    var regex = new RegExp('<img', 'gi')
                                    v.Detail = v.Detail.replace(
                                        regex,
                                        `<img style="max-width: 100%; height: auto"`
                                    )
                                })
                            }

                            if (res.data.Data.Video[0].Path != '') {
                                this.toSee(
                                    res.data.Data.Video[0].Path,
                                    res.data.Data.Video[0].IsFree,
                                    0
                                )
                            } else {
                                this.noVideo = true
                            }
                        } else {
                            this.detail.Video = [{ Path: '', none: 'true' }]
                            this.noVideo = true

                        }
                        if (res.data.Data.Course.IsExam) {
                            this.kinds = [
                                { Name: '课程表', Id: '3' },
                                { Name: '课程介绍', Id: '0' },
                                { Name: '相关附件', Id: '1' },
                                { Name: '相关推荐', Id: '2' },
                                { Name: '考试', Id: '4' }
                            ]
                        }
                    }
                })
            },
            getHelp() {
                getHelps().then((res) => {
                    if (res.data.Code == 0) {
                        this.helpsList = res.data.Data
                    }
                })
            },
            goThird() {
                if (this.detail.Course.ThirdUrl != '') {
                    location.href = this.detail.Course.ThirdUrl
                }
            },
            openPay() {
                if (this.detail.Course.ThirdUrl != '') {
                    location.href = this.detail.Course.ThirdUrl
                    return
                }
                if (this.login()) {
                    let token = localStorage.getItem('AccessToken') || ''
                    let data = {
                        CourseId: this.detail.Course.Id,
                        token: token
                    }
                    orderAdd(data).then((res) => {
                        if (res.data.Code == 0) {
                            console.log(res.data.Data)
                            if (!res.data.Data.NeedPay) {
                                this.$message({
                                    message: res.data.Message,
                                    type: 'success'
                                })
                                setTimeout(() => {
                                    location.reload()
                                }, 1000)
                            } else {
                                this.pay = true
                                this.key = res.data.Data.Key
                            }
                        } else {
                            this.$message({
                                message: res.data.Message,
                                type: 'warning'
                            })
                        }
                    })
                }
            },
            toDetail(id) {
                // this.$router.push({
                //     path: '/creation/detail',
                //     query: { id: id }
                // })
                window.open('/creation/detail?id=' + id)
            },

            //点击切换种类
            handleClick(tab) {
                console.log(tab)
            },

            // 详情
            collect(id) {
                this.$router.push({
                    path: '/competition/winner/detail',
                    query: { paths: '/competition/winner', name: '学习资源', id: id }
                })
            }
        }
    }
</script>
